<template>
    <div v-on-click-outside="close" @click="open">
        <input-text
            class="mx-3 mt-4"
            v-model="search"
            placeholder="Search..."
            @input="runSearch"
            @keyup.down.native.prevent="onDownPress"
            @keyup.up.native.prevent="onUpPress"
            @keyup.enter.native.prevent="onEnterPress"
        ></input-text>

        <div v-if="isOpen && this.search !== '' && this.results.length > 0"  class="left absolute left-3 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <Keypress key-event="keyup" :key-code="27" @success="close" />
            <div class="py-1" role="none">
              <a v-for="(result, index) in results" :key="index" :href="result.edit_route" :class="{'bg-gray-100 text-gray-900': activeElement === index}" class="flex justify-between items-center text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900" role="menuitem" tabindex="-1" id="menu-item-0">
                  <span class="flex-auto text-gray-400 text-xs w-1/4">{{ result.language.iso }}</span>
                  <span class="flex-auto w-3/4" v-html="result.name"></span>
              </a>
            </div>
        </div>

        <div v-if="!requestPending && isOpen && this.search !== '' && this.results.length === 0" class="left absolute left-3 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="py-4 px-4" role="none">
                No documents found
            </div>
        </div>

        <div v-if="requestPending && this.search !== ''" class="left absolute left-3 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="py-4 px-4" role="none">
                Searching...
            </div>
        </div>
    </div>
</template>
<script>
let timer;
export default {
    name: "SearchBar",
    components: {
      Keypress: () => import('vue-keypress')
    },
    data(){
        return {
            search: "",
            isOpen: false,
            activeElement: 0,
            requestPending: false,
            results: [],
        }
    },
    methods: {
        async runSearch(){
            this.results = [];
            this.requestPending = true;
            clearTimeout(timer)
            timer = setTimeout(async () => {
                if(this.search.trim().length === 0) return;
                const {data} = await axios.post(route('document.search'), {searchTerm: this.search})
                this.results = data;
                this.isOpen = true;
                this.requestPending = false;
            }, 300)
        },
        close(){
            this.isOpen = false;
            this.results = [];
        },
        open(){
            this.isOpen = true;
        },
        onDownPress(){
            if(this.activeElement + 1 >= this.results.length) return
            this.activeElement++
        },
        onUpPress(){
            if(this.activeElement - 1 < 0) return
            this.activeElement--
        },
        onEnterPress(){
            if (this.results.length && this.results[this.activeElement] && this.results[this.activeElement].edit_route) {
                window.location.href = this.results[this.activeElement].edit_route;
            }
        },
    }
}
</script>
